import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Communication, CommunicationItem } from "app/model/communication";
import { Observable, throwError } from "rxjs";
import { switchMap } from "rxjs/operators";
import { urls } from "assets/url/urls";

@Injectable()
export class CommunicationService {
  calendarUpdated = new EventEmitter<void>();
  getCalendarEvents() {
    throw new Error("Method not implemented.");
  }
  // Constante de la api de la base de datos
  //private REST_API_SERVER_JSON = 'https://json-portal-empleado.onrender.com';
  private REST_API_SERVER_JSON = urls.baseUrl;
  private TENANT = urls.tenant;

  headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Headers": "Content-Type",
    "X-TENANT-ID": this.TENANT,
  };
  requestOptions = {
    headers: new HttpHeaders(this.headers),
  };

  /**
   * Constructor
   * @param httpClient
   */
  constructor(private httpClient: HttpClient) { }

  handleError(error: HttpErrorResponse) {
    let errorMessage = "Unknown error!";
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  public getCommunicationsByUserId(userId): Observable<CommunicationItem[]> {
    return this.httpClient.get<CommunicationItem[]>(
      this.REST_API_SERVER_JSON + "/communication/" + userId,
      this.requestOptions
    );
  }

  public getCommunications() {
    return this.httpClient.get(
      this.REST_API_SERVER_JSON + "/communication",
      this.requestOptions
    );
  }

  public getOneUserCommunicationById(id) {
    return this.httpClient.get(
      this.REST_API_SERVER_JSON + "/communications/" + id,
      this.requestOptions
    );
  }

  public setAllNonReadCommunicationsUser(id) {
    return this.httpClient.get(
      this.REST_API_SERVER_JSON + "/allNonReadCommunicationsUser/" + id,
      this.requestOptions
    );
  }

  public getOneCommunicationByUid(uid) {
    return this.httpClient.get(
      this.REST_API_SERVER_JSON + "/one_communication/" + uid,
      this.requestOptions
    );
  }

  public getOneCommunicationByid(id) {
    return this.httpClient.get(
      this.REST_API_SERVER_JSON + "/one_communicationById/" + id,
      this.requestOptions
    );
  }

  public getCommunicationFile(id): Observable<any> {
    const headers = new HttpHeaders({
      "X-TENANT-ID": this.TENANT,
    });

    return this.httpClient.get(this.REST_API_SERVER_JSON + "/files/" + id, {
      headers: headers,
      responseType: "blob",
    });
  }

  /**
   * Crea el comunicado en la base de datos
   * @param communcation
   * @returns Usuario
   */
  public addCommunication(communcation: Communication) {
    return this.httpClient.post<Communication>(
      this.REST_API_SERVER_JSON + "/communications",
      communcation,
      this.requestOptions
    );
  }

  /**
   * Actualiza el comunicado con la id seleccionada en la base de datos
   * @param id
   * @param communcation
   * @returns Usuario actualizado
   */
  public updateCommunicationById(id, communcation: Communication) {
    return this.httpClient.put(
      this.REST_API_SERVER_JSON + "/communications/" + id,
      communcation,
      this.requestOptions
    );
  }

  /**
   * Crea el comunicado en la base de datos
   * @param communcation
   * @returns Usuario
   */
  public createCommunication(communcation: Communication) {
    return this.httpClient.post(
      this.REST_API_SERVER_JSON + "/communication",
      communcation,
      this.requestOptions
    );
  }

  public createCommunicationWithFile(id, formdata: FormData) {
    const head = {
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
      "X-TENANT-ID": this.TENANT,
    };

    const requestOpt = {
      headers: new HttpHeaders(head),
    };

    return this.httpClient.post(
      this.REST_API_SERVER_JSON + "/communication-with-file/" + id,
      formdata,
      requestOpt
    );
  }

  /**
   * Borra el comunicado de la base de datos
   * @param id
   * @returns Usuario
   */
  public deleteCommunicationById(id) {
    return this.httpClient.delete(
      this.REST_API_SERVER_JSON + "/communication/" + id,
      this.requestOptions
    );
  }

  public marcarComoLeido(idComunicacion: number): Observable<any> {
    return this.getOneUserCommunicationById(idComunicacion).pipe(
      switchMap((userCommunication: any) => {
        // Marcar la comunicación como leída
        userCommunication.read = true;
        // Actualizar la comunicación con el estado marcado como leído
        return this.updateCommunicationById(idComunicacion, userCommunication);
      })
    );
  }
}
